/**
 * A non-2xx API response as a typed error carrying the status code, so callers
 * (and the global QueryCache handler) can react to 401s consistently. Thrown by
 * the Eden `unwrap` helper in ./api.
 */
export class ApiError extends Error {
  constructor(
    public readonly status: number,
    message?: string,
  ) {
    super(message ?? `Request failed (${status})`);
    this.name = "ApiError";
  }
}
